import { COLORS, FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const MessageContainer = styled.div<{ $marginBottom?: number; $rightMargin: number }>`
  border-radius: 8px;
  padding: 6px 12px;
  background-color: rgba(72, 250, 255, 0.1);
  border: 1px solid rgba(72, 250, 255, 0.4);
  font-size: 14px;
  line-height: 22px;
  color: ${COLORS.textGrey};
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;
  margin-right: ${({ $rightMargin }) => $rightMargin}px;

  .message {
    font-family: ${FONT_FAMILY.hellix.regular};
  }

  a {
    color: ${COLORS.textGrey};
    font-family: ${FONT_FAMILY.hellix.bold};
    text-decoration: underline;
  }
`;

export const DiscountAppliedTag = styled.div<{ $marginTop: number }>`
  display: inline-block;
  padding: 6px 12px;
  margin: 6px 0;
  font-size: 10px;
  line-height: 10px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.textGrey};
  background: rgba(72, 250, 255, 0.1);
  border: 1px solid rgba(72, 250, 255, 0.4);
  border-radius: 6px;
  margin-top: ${({ $marginTop }) => ($marginTop ? $marginTop : 0)}px;
`;

export const DiscountContainer = styled.div<{ $flexStart: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $flexStart }) => ($flexStart ? 'flex-start' : 'flex-end')};
`;
